import React from 'react';
import '../App.css';
import './manualCoverage.css';
import { localizeCoverageCell } from './coverageTranslations';
import { ChakraProvider } from '@chakra-ui/react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
} from '@chakra-ui/react';

// Service Manual Data Coverage sheet (FUSO, Sep 2026). Category names match the
// model dropdown so a technician can go straight from a row to the right filter.
// Columns: vehicle, model year, manual no., volumes, emission code, chassis from, first issued, remarks
const COVERAGE = [
  ['Heavy Duty Bus', [
    ['Aero Queen / Aero Ace (MS)', '2017 (17MS)', '00DHB0053S1–S6', 'Vols. 1–6', '2TG-', '071001~', 'Jun 2017', ''],
    ['Aero Queen / Aero Ace (MS)', '2019 (19MS)', '00DHB0059S1–S6, SA', 'Vols. 1–6 + Vol. A', '2TG-', '080001~', 'Mar 2019', 'Vol. A issued Mar 2022; revised edition incl. service news updates'],
    ['Aero Queen / Aero Ace (MS)', '2021 (21MS)', '00DHB0066', 'Vol. 7', '2TG-', '085001~', 'Mar 2021', '21-Model Dedicated Equipment'],
    ['Aero Queen / Aero Ace (MS)', '2023 (23MS)', '00DHB0068S1–S6, SA', 'Vols. 1–6 + Vol. A', '2TG-', '095001~', 'Sep 2022', 'Full revised set; later service news revisions incorporated'],
    ['Aero Star (MP)', '2017 (17MP)', '00DHB0054 – 0058', 'Vols. 1–5', '2PG-, 2KG-', '069001~', 'Nov 2017', 'No Vol. 6 published for 17MP'],
    ['Aero Star (MP)', '2019 (19MP)', '00DHB0060 – 0065', 'Vols. 1–6', '2PG-, 2KG-', '70001~', 'Sep 2019', ''],
    ['Aero Star (MP)', '2021 (21MP)', '00DHB0067', 'Vol. 7', '2PG-, 2KG-', '76001~', 'Jun 2021', '21-Model Dedicated Equipment'],
  ]],
  ['Heavy Duty Trucks', [
    ['Super Great (FS / FU / FV / FY)', '2017', '00DHT0023S1–S12, SA', 'Vols. 1–12 + Adv. Info', '2KG-, 2PG-, 2RG-', '500001~', 'Jul 2017', '2017 initial set (cover carries no model-year label)'],
    ['Super Great (FS / FU / FV / FY)', '2019 (Wave 1)', '00DHT0024S1–S12, SA', 'Vols. 1–12 + Adv. Info', '2KG-, 2PG-, 2RG-', '510001~ (all); 520001~ (M/T, full trailer)', 'Jun 2019', ''],
    ['Super Great (FS / FU / FV / FY)', '2019', '00DHT0025S1–S10, SA', 'Vols. 1–10 + Adv. Info', '2KG-, 2PG-, 2RG-', '520001~ (excl. M/T, full trailer)', 'Nov 2019', ''],
    ['Super Great (FS / FU / FV / FY)', '2021 (Wave 1)', '00DHT0026S1–S11, SA', 'Vols. 1–11 + Vol. A', '2KG-, 2PG-, 2RG-', '530001~', 'Mar 2021', ''],
    ['Super Great (FS / FU / FV / FY)', '2021', '00DHT0027S1–S10, SA', 'Vols. 1–10 + Vol. A', '2KG-, 2PG-, 2RG-', '540001~', 'Jun 2021', ''],
    ['Super Great (FS / FU / FV / FY)', '2024', '00DHT0028S1–S11, SA', 'Vols. 1–11 + Vol. A', '2KG-, 2PG-, 2RG-', '500001~', 'Feb 2024', 'Vols. 2/3/4 = 6R20 / 6S10 / 6R30 Engines'],
  ]],
  ['Light Duty Bus', [
    ['Rosa (BE / BG)', '2018 (18UE)', '00DLB0013S1–S8', 'Vols. 1–8', 'TPG-, TRG-, TTG-', '400001~', 'Feb 2019', 'Vol. 8 = Advanced Service Information'],
    ['Rosa (BE / BG)', '2019 (19UG)', '00DLB0014S1–S8', 'Vols. 1–8', '2PG-, 2RG-', '100001~', 'Sep 2019', 'Vol. 8 = Advanced Service Information'],
    ['Rosa (BE / BG)', '2021 (21UG)', '00DLB0015S1–S8, SA', 'Vols. 1–8 + Vol. A', '2PG-, 2RG-', '200001~', 'Jun 2021', 'Vol. 8 = Kindergarten Bus Dedicated Equipment'],
    ['Rosa (BE / BG)', '2025', '00DLB0016', 'TBC', 'TBC', 'TBC', '2025', 'Details to be confirmed'],
  ]],
  ['Light Duty Trucks', [
    ['Canter (FE)', '2017 (17TF2)', '00DLT0037S1–S9', 'Vols. 1–9', '2PG-, 2RG-', '560001~', 'Jun 2017', 'Vol. 8 = Adv. Info, Vol. 9 = Low-Floor'],
    ['Canter (FB / FE)', '2018 (18TF1)', '00DLT0038S1–S9, SA', 'Vols. 1–9 + Vol. A', 'TPG-, TRG-', '570001~', 'Mar 2018', 'Vol. 8 = 4WD, Vol. 9 = ECO HYBRID'],
    ['Canter (FB / FE)', '2018.5 (18.5TF1)', '00DLT0039S1–S9, SA', 'Vols. 1–9 + Vol. A', 'TPG-, TRG-', '570001~', 'Jul 2018', 'Vol. 8 = 4WD, Vol. 9 = ECO HYBRID'],
    ['Canter (FB / FE)', '2019 (19TF1)', '00DLT0040S1–S9, SA', 'Vols. 1–8 + Vol. A (+ Vol. 9 eCanter)', '2PG-, 2RG-, 2TG-', '580001~', 'May 2019', 'Vol. 8 = 4WD; Vol. 9 covers eCanter'],
    ['Canter (FB / FE)', '2020 (20TF)', '00DLT0041S1–S8, SA', 'Vols. 1–8 + Vol. A', '2PG-, 2RG-, 2TG-', '590001~', 'Sep 2020', 'Vol. 8 = 4WD'],
    ['Canter (FB / FE)', '2021 (21TF)', '00DLT0042S1–S8, SA', 'Vols. 1–8 + Vol. A', '2PG-, 2RG-, 2TG-', '590001~', 'Feb 2021', 'Vol. 8 = 4WD'],
    ['Canter (FB / FE)', '2021 (21TF2)', '00DLT0043S1–S8, SA', 'Vols. 1–8 + Vol. A', '2PG-, 2RG-, 2TG-', '600001~', 'Oct 2021', 'Vol. 8 = 4WD'],
    ['Canter (FB / FE)', '2023 (23TF)', '00DLT0045S1–S8, SA', 'Vols. 1–8 + Vol. A', '2PG-, 2RG-, 2TG-', '600001~', 'Dec 2022', 'Vol. 8 = 4WD'],
    ['Canter (FB / FE)', '2024 (24TF1)', '00DLT0047S1–S8, SA', 'Vols. 1–8 + Vol. A', '2PG-, 2RG-, 2TG-', '610001~', 'Feb 2024', 'Vol. 8 = 4WD'],
    ['Canter (FB / FE)', '2026 (26TF1)', '00DLT0049S1–S9, SA', 'Vols. 1–9 + Vol. A', 'TBC', 'TBC', 'TBC', 'Vol. 8 = 4WD, Vol. 9 = 26-Model Dedicated Equipment; other details to be confirmed'],
    ['eCanter (FE) – Electric', '2023 (eCanter)', '00DLT0044S1–S7, SA', 'Vols. 1–7 + Vol. A', 'ZAB-', '610001~', 'Feb 2023', 'Vol. 2 = EV System'],
  ]],
  ['Medium Duty Trucks', [
    ['Fighter (FK / FQ)', '2017', '00DMT0008S1–S7', 'Vols. 1–7', '2DG-, 2KG-', '600001~', 'Nov 2017', 'Vol. 2 = 6M6 Engine'],
    ['Fighter (FK)', '2018', '00DMT0009S1–S7', 'Vols. 1–7', '2PG-', '600001~', 'Sep 2018', 'Vol. 2 = 4V20 Engine'],
    ['Fighter (FK / FQ)', '2019', '00DMT0010S1–S8, SA', 'Vols. 1–8 + Vol. A', '2DG-, 2KG-, 2PG-', '605001~', 'Jun 2019', 'Vols. 2/3 = 4V20 / 6M6 Engines'],
    ['Fighter (FK / FQ)', '2019', '00DMT0011S1–S8, SA', 'Vols. 1–8 + Vol. A', '2DG-, 2KG-, 2PG-', '605001~', 'Dec 2020', 'Later 19-model edition'],
    ['Fighter (FK / FQ)', '2021', '00DMT0012S1–S8, SA', 'Vols. 1–8 + Vol. A', '2DG-, 2KG-, 2PG-', '605001~', 'Mar 2021', ''],
    ['Fighter (FK / FQ)', '2023', '00DMT0013S1–S8, SA', 'Vols. 1–8 + Vol. A', '2DG-, 2KG-, 2PG-', '615001~', 'May 2023', ''],
    ['Fighter (FK)', '2024', '00DMT0014S1–S8, SA', 'Vols. 1–8 + Vol. A', '2DG-, 2KG-, 2PG-', '620001~', 'Nov 2023', 'Vols. 2/3 = 4V20 / 6M6 Engines'],
  ]],
];

// Manual numbers are identifiers: the same in every language.
const MANUAL_NO_COLUMN = 2;

const HEADERS = ['Vehicle (Model Codes)', 'Model Year', 'Manual No.', 'Volumes',
  'Emission Reg. Code', 'Chassis No. (From)', 'First Issued', 'Remarks'];

const ManualCoverage = (props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <button className="start-new-btn" style={{ fontSize: props.langOpt === 'Japanese' ? '13px' : '12px' }} onClick={onOpen}>
        <img src="./memo.png" alt="manualCoverageIcon" style={{ width: '20px', height: '20px' }}></img>
        {props.translate('Manual Coverage')}
      </button>
      <ChakraProvider resetCSS={false}>
        <Modal isCentered isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
          <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px) hue-rotate(90deg)" />
          <ModalContent>
            <ModalCloseButton />
            <ModalBody>
              <h2 className="feedback-title">{props.translate('Maintenance manual coverage by model')}</h2>
              <p className="coverage-intro">{props.translate('Pick the manual year that matches your vehicle, using the chassis number range below.')}</p>
              <div className="coverage-scroll">
                <table className="coverage-table">
                  <thead>
                    <tr>{HEADERS.map((h) => <th key={h}>{props.translate(h)}</th>)}</tr>
                  </thead>
                  {COVERAGE.map(([category, rows]) => (
                    <tbody key={category}>
                      <tr className="coverage-category"><th colSpan={HEADERS.length} scope="rowgroup">{props.translate(category)}</th></tr>
                      {rows.map((row) => (
                        <tr key={row[2] + row[6]}>
                          {row.map((cell, i) => (
                            <td key={i}>{i === MANUAL_NO_COLUMN ? cell : localizeCoverageCell(cell, props.langOpt)}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  ))}
                </table>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button onClick={onClose} variant="outline">{props.translate('Close')}</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </ChakraProvider>
    </>
  );
};

export default ManualCoverage;
